import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dniFormat'
})
export class DniFormatPipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) return '';
    const digits = value.toString().replace(/\D/g, '').slice(0, 8);

    if (digits.length <= 2) return digits;
    if (digits.length <= 5) return digits.replace(/^(\d{2,3})(\d{1,3})/, '$1.$2');
    return digits.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2.$3');
  }
}
